import {
    createSlice,
    createAsyncThunk,
    PayloadAction,
    current
} from '@reduxjs/toolkit';
import apiClient from "utils/apiClient";
import { deepEqual } from "utils/common";

interface UserProps {
    email: string
    name: string
    picture: string
    authority: string
    roles: string[]
}

interface UserState {
    info?: UserProps
    isLoggedIn: boolean
    ready: boolean
}

export const initialState:UserState = {
    // info: {
    //     email: 'test@test.test',
    //     name: 'Test User',
    //     authority: 'ADMIN',
    //     roles: []
    // },
    isLoggedIn: false,
    ready: false
};

export const getUserInfo = createAsyncThunk(
    'user/getUserInfo',
    async () => {
        const response = await apiClient.get<UserProps>('/userinfo');
        return response.data;
    }
)

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserInfo.fulfilled, (state, action) => {
                const currentInfo = state.info ? current(state.info) : undefined;

                if (!deepEqual(currentInfo, action.payload)) {
                    state.info = action.payload;
                }
            })
    }
})

export default userSlice.reducer;